module.exports = __webpack_public_path__ + "img/close-circle.a60ceca7.svg";